"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDataLocalStorage = void 0;
var tslib_1 = require("tslib");
var utils_1 = require("@dp-instant/utils");
var inversify_1 = require("inversify");
var CookieDataWeb_1 = require("./CookieDataWeb");
var UserDataLocalStorage = (function (_super) {
    tslib_1.__extends(UserDataLocalStorage, _super);
    function UserDataLocalStorage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ls = window.localStorage;
        _this.keyPrefix = "";
        return _this;
    }
    UserDataLocalStorage.prototype.getCookie = function (c_name) {
        return this.ls.getItem("".concat(this.keyPrefix).concat(c_name)) || "";
    };
    UserDataLocalStorage.prototype.getCookieValue = function (key) {
        var dataString = this.getCookie(key);
        if (dataString) {
            var value = void 0;
            try {
                value = JSON.parse(dataString);
            }
            catch (e) {
                utils_1.log.warn(e, "raw dataString returned");
                value = dataString;
            }
            return value;
        }
    };
    UserDataLocalStorage.prototype.setCookie = function (c_name, value) {
        try {
            this.ls.setItem("".concat(this.keyPrefix).concat(c_name), value);
        }
        catch (error) {
            utils_1.log.error(error);
        }
    };
    UserDataLocalStorage = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], UserDataLocalStorage);
    return UserDataLocalStorage;
}(CookieDataWeb_1.CookieDataWeb));
exports.UserDataLocalStorage = UserDataLocalStorage;
//# sourceMappingURL=UserDataLocalStorage.js.map